
















































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import SustainabilityCompass from '@/charts/SustainabilityCompass.vue';
import CompanyMixin from '@/mixins/CompanyMixin';
import sustainability from '@/utils/Sustainability';
import user from '@/store/modules/user';
import axios from 'axios';

@Component({components: {SustainabilityCompass}})
export default class CardSustainability extends CompanyMixin {
  hovered: any | null = null;

  onHoverChanged(e: any) {
    this.hovered = e;
  }

  download(template: string, fileName: string) {
    user.setFetchingData(true);
    user.setFetchingMessage('Genererar PDF...');

    axios({
      method: 'get',
      url: this.targetUri(template),
      responseType: 'arraybuffer',
    })
        .then((response) => {
          user.setFetchingData(false);
          this.forceFileDownload(response, fileName);
        })
        .catch(() => {
          user.setFetchingData(false);
          console.log('an error occurred');
        });
  }

  targetUri(template: string) {
    const u = user.user;
    if (!u || !this.overview) {
      return;
    }
    return `/api/pdf/quick/sustainability/${u.UserId}/${u.Version}/${
        this.overview.OrgNr
    }/0`;
  }

  forceFileDownload(response: any, fileName: string) {
    const data = new Blob([response.data], { type: 'application/pdf' });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data, fileName);
      return;
    }

    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url);
    }, 100);
  }


  get group() {
    for (const g of sustainability.groups) {
      if (g.name === this.hovered.group) {
        return g;
      }
    }
    return {questions: []};
  }

  get impact() {
    if (this.hovered.value >= 0.2) {
      return 'Betydande';
    } else if (this.hovered.value >= 0.04) {
      return 'Påtaglig';
    }
    return 'Begränsad';
  }
}
